// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lookbook-template__image.image-0[data-v-18d117f3],.lookbook-template__image.image-1[data-v-18d117f3]{margin:0 0 16px}.lookbook-template__image.image-2[data-v-18d117f3]{margin:0 -16px}@media only screen and (min-width:992px){.lookbook-template__image.image-0[data-v-18d117f3]{margin-right:40px;margin-bottom:40px;margin-left:0}.lookbook-template__image.image-1[data-v-18d117f3]{margin-right:0;margin-bottom:40px}.lookbook-template__image.image-2[data-v-18d117f3]{margin:0}}", ""]);
// Exports
module.exports = exports;
